import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Modal, Spinner } from 'react-bootstrap'
import Typography from 'components/atoms/Typography'

function WebformModal(props) {
  const { data } = props
  const [formLoading, setFormLoading] = useState(true)
  const [show, setShow] = useState(true)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  useEffect(async () => {
    const options = {
      done: () => {
        setFormLoading(false)
      },
      error: (err) => {
        console.log('err', err)
      },
    }
    const postscribe = await require('postscribe')
    setTimeout(() => {
      postscribe('#form', `<script src="/webform/${data.formId}/share.js" type="text/javascript"></script>`, options)
    }, 500)

  }, [])

  return (
    <Container fluid="fluid" className={``}>
      <Container>
        <Row>
          <Col>
            <Modal show={show} size="lg" keyboard={false} onHide={handleClose} backdrop="static">
              <Modal.Header closeButton={props.closeable}>
                <Modal.Title>
                  <Typography variant="h6" color="primary">
                    Aviso
                  </Typography>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div id="form">
                  {formLoading && (
                    <Row className="justify-content-md-center my-5">
                      <Col md="auto" className="text-center">
                        <Spinner animation="border" />
                      </Col>
                    </Row>
                  )}
                </div>
              </Modal.Body>

              <Modal.Footer></Modal.Footer>
            </Modal>
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default WebformModal
